module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('div', {
    staticClass: "fade-transition ng-scope",
    attrs: {
      "ng-view": ""
    }
  }, [_c('section', {
    staticClass: "content-header ng-scope"
  }, [_c('h1', [_vm._v("Validação Inicial")]), _vm._v(" "), _c('b-breadcrumb', {
    attrs: {
      "items": _vm.breadcrumb
    }
  })], 1), _vm._v(" "), _c('section', {
    staticClass: "content ng-scope"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "ng-scope ng-isolate-scope",
    attrs: {
      "ng-if": "show.grid"
    }
  }, [_c('div', {
    staticClass: "box box-primary"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "box-body",
    attrs: {
      "id": "dadosCadastrais"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('form', {
    staticClass: "form-horizontal",
    attrs: {
      "name": "frmCommonRegister",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "col-md-7 col-lg-6",
    attrs: {
      "id": "cadastroJuri"
    }
  }, [_c('fieldset', {
    attrs: {
      "disabled": !_vm.isEditable()
    }
  }, [_c('legend', [_vm._v("Dados da entidade:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Razão social')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "Razão social"
    }
  }, [_vm._v("Razão social:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidade.companyName),
      expression: "entidade.companyName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1|max:255'),
      expression: "'required|min:1|max:255'"
    }],
    ref: "Razão social",
    staticClass: "form-control",
    attrs: {
      "name": "Razão social",
      "type": "text"
    },
    domProps: {
      "value": (_vm.entidade.companyName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entidade, "companyName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('Razão social')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Razão Social é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('CNPJ')
    }
  }, [_c('label', {
    ref: "CNPJ",
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "CNPJ"
    }
  }, [_vm._v("CNPJ:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-lg-4"
  }, [_c('the-mask', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:14|max:14'),
      expression: "'required|min:14|max:14'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "CNPJ",
      "type": "text",
      "mask": "##.###.###/####-##"
    },
    model: {
      value: (_vm.entidade.cnpj),
      callback: function($$v) {
        _vm.$set(_vm.entidade, "cnpj", $$v)
      },
      expression: "entidade.cnpj"
    }
  }), _vm._v(" "), (_vm.errors.first('CNPJ')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo CNPJ é obrigatório')))]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('cnpjExpeditionTime')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "cnpjExpeditionTime"
    }
  }, [_vm._v("Expedição CNPJ:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-lg-4"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "cnpjExpeditionTime",
    attrs: {
      "name": "cnpjExpeditionTime",
      "input-class": "form-control datepicker",
      "language": _vm.$datePickerPtBR,
      "maxlength": "20",
      "use-utc": true,
      "placeholder": "__ /__ /____",
      "format": "dd/MM/yyyy"
    },
    model: {
      value: (_vm.entidade.cnpjExpeditionTime),
      callback: function($$v) {
        _vm.$set(_vm.entidade, "cnpjExpeditionTime", $$v)
      },
      expression: "entidade.cnpjExpeditionTime"
    }
  }), _vm._v(" "), (_vm.errors.first('cnpjExpeditionTime')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Expedição do CNPJ é obrigatório')))]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Nome fantasia')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "Nome fantasia"
    }
  }, [_vm._v("Nome fantasia:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidade.businessName),
      expression: "entidade.businessName"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1|max:255'),
      expression: "'required|min:1|max:255'"
    }],
    ref: "Nome fantasia",
    staticClass: "form-control",
    attrs: {
      "name": "Nome fantasia",
      "type": "text"
    },
    domProps: {
      "value": (_vm.entidade.businessName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entidade, "businessName", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('Nome fantasia')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Nome fantasia é obrigatório')))]) : _vm._e()])]), _vm._v(" "), (!_vm.entidade.simplified) ? _c('fieldset', [_c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Natureza jurídica')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "Natureza jurídica"
    }
  }, [_vm._v("Natureza jurídica:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidade.legalType),
      expression: "entidade.legalType"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "Natureza jurídica",
    staticClass: "form-control",
    attrs: {
      "name": "Natureza jurídica"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entidade, "legalType", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "ASSOCIAÇÃO"
    }
  }, [_vm._v("Associação")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "COOPERATIVA"
    }
  }, [_vm._v("Cooperativa")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "EMPRESA_PUBLICA"
    }
  }, [_vm._v("Empresa pública")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FUNDACAO"
    }
  }, [_vm._v("Fundação")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ORGAO_PUBLICO_EXECUTIVO_ESTADUAL"
    }
  }, [_vm._v("Orgão público executivo estadual")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ORGAO_PUBLICO_EXECUTIVO_MUNICIPAL"
    }
  }, [_vm._v("Orgão público executivo municipal")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SEM_FINS_LUCRATIVOS"
    }
  }, [_vm._v("Sem fins lucrativos")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SERVICO_SOCIAL_AUTONOMO"
    }
  }, [_vm._v("Serviço social autônomo")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SOCIEDADE_LTDA"
    }
  }, [_vm._v("Sociedade ltda")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SOCIEDADE_POR_ACOES"
    }
  }, [_vm._v("Sociedade por Ações")])]), _vm._v(" "), (_vm.errors.first('Natureza jurídica')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Natureza jurídica é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Ramo atividade')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "Ramo atividade"
    }
  }, [_vm._v("Ramo atividade:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidade.activity),
      expression: "entidade.activity"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "Ramo atividade",
    staticClass: "form-control",
    attrs: {
      "name": "Ramo atividade"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entidade, "activity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.ramoAtividade), function(ramoAtividade) {
    return _c('option', {
      attrs: {
        "label": ramoAtividade.code + ' - ' + ramoAtividade.description
      },
      domProps: {
        "value": ramoAtividade
      }
    }, [_vm._v(_vm._s(ramoAtividade.code + ' - ' + ramoAtividade.description))])
  }), 0), _vm._v(" "), (_vm.errors.first('Ramo atividade')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Ramo atividade é obrigatório')))]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Doc. constituição')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "constitutionDocument"
    }
  }, [_vm._v("Doc. constituição:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidade.constitutionDocument),
      expression: "entidade.constitutionDocument"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    ref: "Doc. constituição",
    staticClass: "form-control",
    attrs: {
      "name": "Doc. constituição"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.entidade, "constitutionDocument", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "ATA_CONSTITUICAO"
    }
  }, [_vm._v("Ata constituição")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CONTRATO_SOCIAL"
    }
  }, [_vm._v("Contrato social")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ESTATUTO"
    }
  }, [_vm._v("Estatuto")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "LEI_ORGANICA_MUNICIPAL"
    }
  }, [_vm._v("Lei orgânica municipal")])]), _vm._v(" "), (_vm.errors.first('Doc. constituição')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Doc. constituição é obrigatório')))]) : _vm._e()])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-5 col-lg-6",
    attrs: {
      "id": "contato"
    }
  }, [_c('fieldset', [_c('legend', [_vm._v("Contato:")]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Telefone')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "Telefone"
    }
  }, [_vm._v("Telefone:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-lg-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidade.contact.phone),
      expression: "entidade.contact.phone"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(##) ####-#####'),
      expression: "'(##) ####-#####'"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1'),
      expression: "'required|min:1'"
    }],
    ref: "Telefone",
    staticClass: "form-control",
    attrs: {
      "masked": _vm.masked,
      "name": "Telefone",
      "type": "text"
    },
    domProps: {
      "value": (_vm.entidade.contact.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entidade.contact, "phone", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('Telefone')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo Telefone é obrigatório')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "mobile"
    }
  }, [_vm._v("Celular:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-lg-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidade.contact.mobile),
      expression: "entidade.contact.mobile"
    }, {
      name: "mask",
      rawName: "v-mask",
      value: ('(##) #####-#####'),
      expression: "'(##) #####-#####'"
    }],
    staticClass: "form-control",
    attrs: {
      "masked": _vm.masked,
      "name": "mobile",
      "type": "text"
    },
    domProps: {
      "value": (_vm.entidade.contact.mobile)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entidade.contact, "mobile", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group required-field",
    class: {
      'has-error': _vm.errors.first('Email')
    }
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("E-Mail:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidade.email),
      expression: "entidade.email"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:1|max:255'),
      expression: "'required|min:1|max:255'"
    }],
    ref: "Email",
    staticClass: "form-control",
    attrs: {
      "name": "Email",
      "type": "text",
      "delivery": "account",
      "method": "uniqueUserEmail"
    },
    domProps: {
      "value": (_vm.entidade.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entidade, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.errors.first('Email')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(('O campo E-mail é obrigatório')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "control-label col-md-4",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Site:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.entidade.website),
      expression: "entidade.website"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:255'),
      expression: "'max:255'"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "website",
      "type": "text"
    },
    domProps: {
      "value": (_vm.entidade.website)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.entidade, "website", $event.target.value)
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(1), _vm._v(" "), _c('endereco', {
    attrs: {
      "entEnderecos": _vm.endereco
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(2), _vm._v(" "), _c('dirigentes', {
    attrs: {
      "entDirigentes": _vm.dirigentes,
      "name": "dirigentes"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(3), _vm._v(" "), _c('usuarios', {
    attrs: {
      "entUsuarios": _vm.usuarios
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('upload-documentos', {
    attrs: {
      "propDocumentos": _vm.entidade.documents,
      "documentTypes": _vm.entidade.documentTypes
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_vm._m(5), _vm._v(" "), _c('historico-entidade', {
    attrs: {
      "entHistorico": _vm.historico
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-lg-12"
  }, [_c('legend', [_vm._v("Decisões da análise da entidade:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group required full",
    class: {
      'has-error': _vm.errors.first('resultado')
    },
    staticStyle: {
      "margin-right": "0",
      "margin-left": "0"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "approvalResult"
    }
  }, [_vm._v("Decisões:")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.analise.approvalResult),
      expression: "analise.approvalResult"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "resultado",
      "id": "resultado",
      "value": "APPROVED"
    },
    domProps: {
      "checked": _vm._q(_vm.analise.approvalResult, "APPROVED")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.analise, "approvalResult", "APPROVED")
      }
    }
  }), _vm._v(" Aprovar\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.analise.approvalResult),
      expression: "analise.approvalResult"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "resultado",
      "value": "REVIEW_OPENED"
    },
    domProps: {
      "checked": _vm._q(_vm.analise.approvalResult, "REVIEW_OPENED")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.analise, "approvalResult", "REVIEW_OPENED")
      }
    }
  }), _vm._v(" Devolver para ajustes\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('label', {
    staticClass: "radio-inline new-control new-control-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.analise.approvalResult),
      expression: "analise.approvalResult"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "type": "radio",
      "name": "resultado",
      "value": "CANCELED"
    },
    domProps: {
      "checked": _vm._q(_vm.analise.approvalResult, "CANCELED")
    },
    on: {
      "change": function($event) {
        return _vm.$set(_vm.analise, "approvalResult", "CANCELED")
      }
    }
  }), _vm._v(" Reprovar\n                        "), _c('div', {
    staticClass: "new-control-indicator"
  })])]), _vm._v(" "), (_vm.errors.first('resultado')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('resultado')))]) : _vm._e(), _vm._v(" "), _c('br')]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), (_vm.analise.approvalResultt === 'REJECTED' || _vm.analise.approvalResult === 'REVIEW_OPENED') ? _c('div', {
    staticClass: "form-group required full",
    class: {
      'has-error': _vm.errors.first('justificativa')
    },
    staticStyle: {
      "margin-right": "0",
      "margin-left": "0"
    }
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "justificativa"
    }
  }, [_vm._v("Justificativa:")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.analise.justify),
      expression: "analise.justify"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "form-control",
    staticStyle: {
      "height": "150px",
      "resize": "none"
    },
    attrs: {
      "name": "justificativa",
      "id": "justificativa"
    },
    domProps: {
      "value": (_vm.analise.justify)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.analise, "justify", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.errors.first('justificativa')) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v(" " + _vm._s(_vm.errors.first('justificativa')))]) : _vm._e()]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn btn-success btn-flat",
    attrs: {
      "uib-tooltip": "Conclui o cadastro",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.conclui(_vm.frmCommonRegister)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Concluir")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "uib-tooltip": "Apenas salva o cadastro",
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.salva(_vm.frmCommonRegister)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Salvar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-flat",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          path: '/validacao/validacaoInicial/lista'
        })
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Voltar à lista")])])])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Cadastro da Entidade")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Endereço:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Dirigentes:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Usuários da entidade:")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Documentos Upload")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box box-widget"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Histórico:")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e620aeb2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/validação/validacaoInicial/ValidaInicial.vue
// module id = 1971
// module chunks = 2